import { render, staticRenderFns } from "./SupplierSelector.vue?vue&type=template&id=7656a7cf&scoped=true"
import script from "./SupplierSelector.vue?vue&type=script&lang=js"
export * from "./SupplierSelector.vue?vue&type=script&lang=js"
import "./SupplierSelector.vue?vue&type=style&index=0&id=7656a7cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7656a7cf",
  null
  
)

export default component.exports